module.exports = __webpack_public_path__ + "img/logo-dark.8389daf6.png";